

import BasicList from "../../../basic-list";

export default class FinanceSourcePage extends BasicList {

}